var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time"},[_c('span',{attrs:{"title":_vm.standardTime(_vm.time)}},[_vm._v(_vm._s(_vm.formatTime(_vm.time)))])])}
var staticRenderFns = []

export { render, staticRenderFns }